








































import { defineComponent } from "@vue/composition-api";
import Expandable from "@/components/Expandable.vue";
import NumberFormatter from "@/services/number.formatter";
import { BlockLabel } from "@/models/BlockLabel";
import ErrorLabel from "../ErrorLabel.vue";

const defaultMin = 1000;
const defaultMax = 2000;

export default defineComponent({
  name: "MinMax",
  components: {
    Expandable,
    ErrorLabel,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      displayName: BlockLabel.MinMax,
      minAmount: defaultMin,
      maxAmount: defaultMax,
    };
  },
  computed: {
    isMinEnabled(): boolean {
      return this.minAmount !== null && this.minAmount > 0;
    },
    isMaxEnabled(): boolean {
      return this.maxAmount !== null && this.maxAmount > 0;
    },
  },
  mounted() {
    if (this.data) {
      this.minAmount = this.data.minAmount;
      this.maxAmount = this.data.maxAmount;
    }
  },
  methods: {
    isNeitherMinOrMaxChosen(): boolean {
      return !this.isMaxEnabled && !this.isMinEnabled;
    },
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        minAmount: this.minAmount > 0 ? this.minAmount : null,
        maxAmount: this.maxAmount > 0 ? this.maxAmount : null,
      });
    },
    asCurrency: (number: number) =>
      `kr ${NumberFormatter.withThousandsSeparator(number, " ")}`,
  },
});
